import React, { useState } from 'react';
import { Button, Segment, Header, Grid, Accordion, Icon } from 'semantic-ui-react';
import moment from 'moment';
import cogoToast from "cogo-toast";
import PdfAxios from "../../axiosComponent/downloadpdf";

const SingleInvoice = ({ invoices, deliveryIndex, orderDetail, t, }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  let downloadGoodsInvoiceFile = (invoiceid) => {
    PdfAxios({
      completeURL: `${process.env.REACT_APP_BASE_URL}/v1/common-services/invoice/download?invoice_id=${invoiceid}`,
    })
      .then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          cogoToast.success("File Downloaded Successfully")
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <Accordion fluid styled>
      {invoices && invoices.map((invoice, invoiceIndex) => {
        return (
          <React.Fragment>
            <Accordion.Title
              active={activeIndex === invoiceIndex}
              index={invoiceIndex}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              {`Invoice ${invoiceIndex + 1}`}
            </Accordion.Title>
            <Accordion.Content active={activeIndex === invoiceIndex}>
              <div className="pad w3-white small">
                <Grid columns={4}>
                  <Grid.Column width="3">
                    {orderDetail.movement_type == "Import" || orderDetail.movement_type == "Importar" ?
                      <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                        {t("boe_no") || "BOE No"}
                      </Header>
                      :
                      <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                        {t("invoice_number") || "Invoice No"}
                      </Header>
                    }
                  </Grid.Column>
                  <Grid.Column width="4">
                    {orderDetail.movement_type == "Import" || orderDetail.movement_type == "Importar" ?
                      <Header className="p-bold-600 labelName" size="tiny" as="label" color="black">
                        {invoice.boe_no || "NA"}
                      </Header>
                      :
                      <Header className="p-bold-600 labelName" size="tiny" as="label" color="black">
                        {invoice.invoice_no || "NA"}
                      </Header>
                    }
                  </Grid.Column>

                  <Grid.Column width="3">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                      {t("invoice_amount") || "Invoice Amount"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width="4">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="black">
                      {invoice.invoice_amount || "NA"}
                    </Header>
                  </Grid.Column>

                  <Grid.Column width="3">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                      {t("invoice_date") || "Invoice Date"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width="4">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="black">
                      {invoice.invoice_date ? moment.parseZone(invoice.invoice_date).format('DD-MM-YYYY') : "NA"}
                    </Header>
                  </Grid.Column>

                  <Grid.Column width="3">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                      {t("quantity") || "Quantity"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width="4">
                    <Header className="p-bold-600 labelName" size="tiny" as="label" color="black">
                      {invoice.invoice_quantity || "NA"}
                    </Header>
                  </Grid.Column>
                  {invoice?.invoice_document_path
                    ?
                    <>
                      <Grid.Column width="3">
                        <Header className="p-bold-600 labelName" size="tiny" as="label" color="grey">
                          {"Goods Invoice"}
                        </Header>
                      </Grid.Column>
                  <Grid.Column width="4">
                      <Button size="mini"
                        basic type="button"
                        onClick={() => downloadGoodsInvoiceFile(
                          invoice.id
                        )}
                        color="primary"
                        icon>
                        <Icon name="download" />
                      </Button>
                  </Grid.Column>
                    </>
                    :
                    null
                  }
                </Grid>
              </div>
            </Accordion.Content>
          </React.Fragment>
        )
      })}
    </Accordion>

  )
}

export default SingleInvoice;